<template>
  <div>
    <ui-block-text-editor v-model="content2"></ui-block-text-editor>
    <pre class="mt-20 bg-gray-200 text-xs" :value="content">
      {{ content2 }}
    </pre>
    <div v-html="content2"></div>


    <pre class="mt-20 bg-gray-200 text-xs" :value="content">
      {{ content }}
    </pre>

  </div>
</template>

<script>
import UiBlockTextEditor from "@/components/ui/content/UiBlockTextEditor";

export default {
  name: "UiBlockEditor",
  components: {
        UiBlockTextEditor,
  },
  data() {
    return {
      content2: null,
      content:
      [
        {
          name: 'item 1',
          items: [
            {
              name: 'item 2',
              items: [],
            },
          ],
        },
        {
          name: 'item 3',
          items: []
        },

      ],
    }
  },
}
</script>
<style scoped></style>

//name: "UiBlockEditor",
//import { VueDraggableNext } from 'vue-draggable-next'